import styled from 'styled-components'
import TextField from '@mui/material/TextField';
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

const Container=styled.div`
	width:80%;
	margin:10px;
	font-size:13px;
	font-fdamily:'Poppins', 'sans-serif';
	color:white
	
  `;


export default function RowOptopn(props){
	const { label,value,estado,action} = props;
	let dispatch=useDispatch();
	
	let handleChange=(e)=>{	
		dispatch(action( {[label]:e.target.value} ))
	};

	useEffect(()=>{
		switch(estado){
			case 1:
				document.getElementById(label).value="";
				dispatch( action( {[label]:""} ))
				break
			case 2:
				let valor=document.getElementById(label).value;
				dispatch( action( {[label]:valor} ));
				break
			default:
				let valor1=document.getElementById(label).value;
				dispatch( action( {[label]:valor1} ));
		}	
		
		
	},[estado,action,dispatch,label]);


	
	return(
		<Container>
		  <div>
				<label htmlFor={label}><b>{label}</b></label>
				{estado===0?<TextField fullWidth disabled id={label} size="small" value={value} />:
				<TextField fullWidth  id={label}  size="small"  onChange={handleChange} defaultValue={value} />}
			</div>
		</Container>

		)
}












